import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';
import { BaseCard } from '../base';

interface DashboardWidgetCardProps {
  title: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
}

const CardContentStyled = styled(CardContent)`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: ${({ theme }) => theme.spacing(2.5)};

  &:last-child {
    padding-bottom: ${({ theme }) => theme.spacing(2.5)};
  }
`;

const CardTitle = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1.25)};
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
`;

const TitleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  min-width: 0;
  gap: ${({ theme }) => theme.spacing(1.25)};
`;

const Accent = styled.span`
  flex: 0 0 auto;
  width: 10px;
  height: 34px;
  border-radius: 999px;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.palette.secondary.main},
    ${({ theme }) => theme.palette.primary.main}
  );
  box-shadow: 0 8px 18px ${({ theme }) => theme.palette.primary.light};
`;

const CardBody = styled(Box)`
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
`;

const DashboardWidgetCard = ({ title, children, actions }: DashboardWidgetCardProps) => (
  <BaseCard className="dashboard-widget-card">
    <CardContentStyled>
      <CardTitle>
        <TitleWrapper>
          <Accent />
          <Typography variant="subtitle1">{title}</Typography>
        </TitleWrapper>
        {actions}
      </CardTitle>
      <Divider />
      <CardBody>{children}</CardBody>
    </CardContentStyled>
  </BaseCard>
);

export default DashboardWidgetCard;
